(function (angular) {
  /**
   * For maintainability we should separate controllers into their own modules
   */
  angular
    .module('acme.view.application.membership.pricing.discounts.create.controllers', [
      'ui.router',
      'ui.bootstrap',
      'acme.common.service.api',
      'acme.common.service.helpers',
      'acme.common.factory.notice',
      'acme.common.factory.node',
      'acme.common.service.permissions',
      'acme.common.directive.tree',
      'acme.view.application.membership.pricing.discounts.component.pricingCheckbox',
    ])
    .controller('MembershipPricingDiscountsCreateController', MembershipPricingDiscountsCreateController);

  MembershipPricingDiscountsCreateController.$inject = [
    '$scope',
    '$state',
    '$uibModal',
    '$timeout',
    'ApiService',
    'HelpersService',
    'PermissionsService',
    'NoticeFactory',
    'NodeFactory',
  ];

  function MembershipPricingDiscountsCreateController(
    $scope,
    $state,
    $uibModal,
    $timeout,
    ApiService,
    HelpersService,
    PermissionsService,
    NoticeFactory,
    NodeFactory
  ) {
    $scope.membershipPricingDiscountsCreate = {
      model: {},

      membershipLevels: [],

      couponCategories: [],

      discounts: [],

      existingDiscounts: [],

      mode: 'create',

      noticeTimer: {},

      notice: new NoticeFactory(),

      tree: {
        node: new NodeFactory({}),
        model: { selected: false, partial: false },
      },

      init: function () {
        if ($state.params.id) {
          this.mode = 'edit';
        }
        $scope.$emit('Application::contentTitleChange', {
          title: this.isMode('edit') ? 'Edit Membership Coupon Discount' : 'New Membership Coupon Discount',
          buttonRight: {
            permissions: this.isMode('edit')
              ? 'MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_UPDATE'
              : 'MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_CREATE',
            label: this.isMode('edit') ? 'Save' : 'Create',
            action: function () {
              $scope.membershipPricingDiscountsCreate.save();
            },
          },
          buttonLeft: {
            label: 'Close',
            action: function () {
              $scope.membershipPricingDiscountsCreate.close();
            },
          },
        });

        this.getCouponDiscounts();
      },

      getCouponDiscounts: function () {
        var props = HelpersService.getPaginator();
        if ($state.params.action) {
          props.lifecycleActions = [$state.params.action];
        }
        ApiService.membership.lifecycle.discounts.list(props).then(this.success.init, this.error.init);
      },

      getDiscounts: function () {
        return ApiService.discounts
          .list('v2', HelpersService.getPaginator())
          .then(this.success.getDiscounts, this.error.getDiscounts);
      },

      getCouponCategories: function () {
        return ApiService.coupons.categories
          .list(HelpersService.getPaginator())
          .then(this.success.getCouponCategories, this.error.getCouponCategories);
      },

      getMembershipLevels: function (group) {
        var props = HelpersService.getPaginator();

        props.salesChannels = 'online,insideSalesIndividual,pointOfSale,reseller,manualEntry,customerRep';
        props.isPublished = '1';
        props.summarize = '1';
        if (group) {
          props.membershipLevelGroup = group;
        }

        ApiService.membership.categories
          .list(props)
          .then(this.success.getMembershipLevels, this.error.getMembershipLevels);
      },

      isMode: function (mode) {
        return this.mode === mode;
      },

      findItem: function (itemId, list) {
        var i,
          ii,
          r = false;

        list = list || [];

        for (i = 0, ii = list.length; i < ii; i++) {
          if (itemId === list[i].id) {
            r = {
              item: list[i],
              index: i,
            };
            break;
          }
        }

        return r;
      },

      process: function () {
        var i, ii;
        for (i = 0, ii = this.existingDiscounts.length; i < ii; i++) {
          if (this.isMode('edit') && $state.params.id && $state.params.id === this.existingDiscounts[i].id) {
            this.model = this.existingDiscounts[i];
            break;
          }
        }
      },

      processCouponCategories: function () {
        var i,
          ii,
          found = false;

        for (i = 0, ii = this.existingDiscounts.length; i < ii; i++) {
          if (
            this.existingDiscounts[i].hasOwnProperty('couponCategory') &&
            this.existingDiscounts[i].couponCategory.id
          ) {
            found = this.findItem(this.existingDiscounts[i].couponCategory.id, this.couponCategories);
            if (found) {
              if (this.isMode('edit')) {
                if (
                  this.model.couponCategory &&
                  this.model.couponCategory.id &&
                  found.item.id !== this.model.couponCategory.id
                ) {
                  this.couponCategories.splice(found.index, 1);
                } else {
                  this.model.couponCategory = found.item;
                }
              } else {
                this.couponCategories.splice(found.index, 1);
              }
            }
          }
        }
      },

      processDiscounts: function () {
        var found;
        if (this.isMode('edit') && this.model.discount && this.model.discount.id) {
          found = this.findItem(this.model.discount.id, this.discounts);
          if (found) {
            this.model.discount = found.item;
          }
        }
      },

      toggleTree: function () {
        var self = $scope.membershipPricingDiscountsCreate;

        self.tree.node.traverseChildren(function (node) {
          node.value.model.selected = self.tree.model.selected;
        });

        self.updateTree();
      },

      getNodeMetadataFromTreeNodeCtrl: function (nodeCtrl) {
        var totalNodes = 0;
        var countSelected = 0;

        nodeCtrl.node.traverseChildren(function (node) {
          totalNodes += 1;

          if (node.value.model.selected) {
            countSelected += 1;
          }
        });

        return {
          total: totalNodes,
          selected: countSelected,
        };
      },

      isNodeCtrlPartiallySelected: function (treeNodeCtrl) {
        var self = $scope.membershipPricingDiscountsCreate;
        var metadata = self.getNodeMetadataFromTreeNodeCtrl(treeNodeCtrl);

        return metadata.selected > 0 && metadata.selected < metadata.total;
      },

      isNodeCtrlSelected: function (treeNodeCtrl) {
        var self = $scope.membershipPricingDiscountsCreate;

        if (treeNodeCtrl.node.isLeaf()) {
          return treeNodeCtrl.model ? !!treeNodeCtrl.model.selected : false;
        }

        var metadata = self.getNodeMetadataFromTreeNodeCtrl(treeNodeCtrl);

        return metadata.selected > 0;
      },

      toggleNode: function (treeNodeCtrl, nodeModel) {
        var self = $scope.membershipPricingDiscountsCreate;
        var selected = nodeModel.selected;

        treeNodeCtrl.node.traverseChildren(function (node) {
          if (node) {
            var indeterminate = self.isNodeCtrlPartiallySelected(node.value);

            node.value.model.selected = selected;
            node.value.model.partial = indeterminate;
          }
        });

        nodeModel.partial = self.isNodeCtrlPartiallySelected(treeNodeCtrl);

        self.updateTree();
      },

      updateTree: function () {
        var self = $scope.membershipPricingDiscountsCreate;

        self.tree.node.traverseChildren(function (node) {
          node.value.model.partial = self.isNodeCtrlPartiallySelected(node.value);
          node.value.model.selected = self.isNodeCtrlSelected(node.value);
        });

        var selected = self.isNodeCtrlSelected(self.tree.node.value);
        var partial = self.isNodeCtrlPartiallySelected(self.tree.node.value);

        self.tree.model.partial = partial;
        self.tree.model.selected = selected;
      },

      selectMemberships: function () {
        var i,
          ii,
          j,
          jj,
          membershipDiscountLevel,
          found = false,
          foundOffering = false;
        for (i = 0, ii = this.model.membershipLevelInfo.length; i < ii; i++) {
          membershipDiscountLevel = this.model.membershipLevelInfo[i];

          if (
            membershipDiscountLevel.membershipOfferings instanceof Array &&
            membershipDiscountLevel.membershipOfferings.length
          ) {
            found = this.findItem(membershipDiscountLevel.membershipLevel.id, this.membershipLevels);
            if (found && found.item.offerings instanceof Array && found.item.offerings.length) {
              for (j = 0, jj = membershipDiscountLevel.membershipOfferings.length; j < jj; j++) {
                foundOffering = this.findItem(membershipDiscountLevel.membershipOfferings[j].id, found.item.offerings);
                if (foundOffering) {
                  foundOffering.item.selected = true;
                }
              }
              this.updateMembershipLevelSelection(found.item);
            }
          }
        }
      },

      updateMembershipLevelSelection: function (level) {
        var self = $scope.membershipPricingDiscountsCreate;
        var selected = [];

        level.partial = false;
        level.selected = false;

        if (level && Array.isArray(level.offerings)) {
          selected = level.offerings.filter(function (offering) {
            return offering.selected;
          });

          if (selected.length) {
            if (selected.length < level.offerings.length) {
              level.partial = true;
            } else if (selected.length === level.offerings.length) {
              level.selected = true;
              level.partial = false;
            }
          }
        }
      },

      marshal: function () {
        var i,
          ii,
          j,
          jj,
          memberships = [],
          offerings = [];
        for (i = 0, ii = this.membershipLevels.length; i < ii; i++) {
          if (this.membershipLevels[i].selected || this.membershipLevels[i].partial) {
            offerings = [];
            for (j = 0, jj = this.membershipLevels[i].offerings.length; j < jj; j++) {
              if (this.membershipLevels[i].offerings[j].selected) {
                offerings.push({
                  id: this.membershipLevels[i].offerings[j].id,
                  name: this.membershipLevels[i].offerings[j].name,
                });
              }
            }
            if (offerings.length) {
              memberships.push({
                membershipLevel: {
                  id: this.membershipLevels[i].id,
                  name: this.membershipLevels[i].name,
                },
                membershipOfferings: offerings,
                supportAllOfferings: false,
              });
            }
          }
        }

        return memberships;
      },

      save: function () {
        var data = [];

        this.notice.hideErrorMessages();

        if (!this.model.couponCategory) {
          this.notice.showErrorMessages([{ message: 'Please choose a coupon category.' }]);
        } else if (!this.model.discount) {
          this.notice.showErrorMessages([{ message: 'Please choose a discount.' }]);
        } else {
          data = this.marshal();

          if (data.length) {
            if (this.isMode('edit')) {
              ApiService.membership.lifecycle.discounts
                .update({
                  id: this.model.id,
                  membershipLevelInfo: data,
                  couponCategory: this.model.couponCategory,
                  discount: this.model.discount,
                  lifecycleAction: $state.params.action,
                })
                .then(this.success.save, this.error.save);
            } else {
              ApiService.membership.lifecycle.discounts
                .create({
                  membershipLevelInfo: data,
                  couponCategory: this.model.couponCategory,
                  discount: this.model.discount,
                  lifecycleAction: $state.params.action,
                })
                .then(this.success.save, this.error.save);
            }
          } else {
            this.notice.showErrorMessages([{ message: 'Please choose at least one membership offering' }]);
          }
        }
      },

      close: function () {
        $state.go('application.membership.pricing.discounts');
      },

      showCoupons: function (couponCategoryId) {
        var self = $scope.membershipPricingDiscountsCreate;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/templates/modals/showCouponsModal.tpl.html',
          size: 'md',
          controller: 'TemplatesShowCouponsModalController',
          resolve: {
            CouponCategoryListData: function () {
              return ApiService.coupons.getCouponsByCategory(couponCategoryId, HelpersService.getPaginator());
            },
          },
        });

        // Invoked when modal completes with close(params)

        self.showModal.result.then(angular.noop, angular.noop);
      },

      success: {
        init: function (response) {
          var self = $scope.membershipPricingDiscountsCreate;
          self.existingDiscounts = response.data.payload.list;
          self.process();
          self.isLoaded = true;
          self.getDiscounts();
          self.getCouponCategories();
          self.getMembershipLevels();
        },
        getDiscounts: function (response) {
          var self = $scope.membershipPricingDiscountsCreate;
          self.discounts = response.data.payload.list;
          self.processDiscounts();
        },
        getCouponCategories: function (response) {
          var self = $scope.membershipPricingDiscountsCreate;
          self.couponCategories = response.data.payload.list;
          self.processCouponCategories();
        },
        getMembershipLevels: function (response) {
          var self = $scope.membershipPricingDiscountsCreate;
          self.membershipLevels = response.data.payload.list;
          if (self.isMode('edit')) {
            self.selectMemberships();
          }

          $timeout(function () {
            // We have to wait until the next tick because TreeNodes haven't been created on the DOM yet
            self.updateTree();
          }, 0);
        },
        save: function (response) {
          var self = $scope.membershipPricingDiscountsCreate;

          if (self.isMode('edit')) {
            $timeout.cancel($scope.noticeTimer);
            self.notice.showSuccessMessages([{ message: 'Successfully Saved!' }]);

            $scope.noticeTimer = $timeout(function () {
              self.notice.hideSuccessMessages();
            }, 3000);
          } else {
            if (PermissionsService.check('MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_UPDATE')) {
              $state.go('application.membership.pricing.discounts.edit', { id: response.data.payload.id });
            } else {
              self.close();
            }
          }
        },
      },

      error: {
        init: function (response) {
          var self = $scope.membershipPricingDiscountsCreate;

          self.getDiscounts();
          self.getCouponCategories();
          self.getMembershipLevels();
        },
        getDiscounts: function (response) {},
        getMembershipLevels: function (response) {},
        removeMembershipCouponDiscount: function (response) {
          $scope.membershipPricingDiscountsCreate.notice.showErrorMessages([{ message: response.data.error }]);
        },
        save: function (response) {
          $scope.membershipPricingDiscountsCreate.notice.showErrorMessages([{ message: response.data.error }]);
        },
      },

      onLevelChange: function (level) {
        var self = $scope.membershipPricingDiscountsCreate;

        $timeout(function () {
          if (!Array.isArray(level.offerings)) {
            return;
          }

          var selected = level.selected || level.partial;
          level.offerings.forEach(function (offering) {
            offering.selected = selected;
          });
        }, 0);
      },

      onOfferingChange: function (offering, level) {
        $timeout(function () {
          $scope.membershipPricingDiscountsCreate.updateMembershipLevelSelection(level);
        }, 0);
      },
    };

    $scope.membershipPricingDiscountsCreate.init();
  }
})(window.angular);
